export const COUNTRY_ADDRESS_FIELDS = {
	quarter: ['bg'],
	streetNumber: ['ro', 'bg'],
	entrance: ['ro', 'bg'],
	staircase: ['ro', 'bg'],
	floor: ['ro', 'bg'],
	businessOrComplexName: ['bg'],
};
